export default __webpack_public_path__ + "static/media/icon_gmail.dbf14da7.png";